enum colorModes {
  LIGHT = "light",
  DARK = "dark",
  SYSTEM = "system",
}

export default colorModes;
